import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { DateObject, Document_Upload_File, ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { Observable, of, tap } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { Organization } from 'src/app/models/um/organization';

@Component({
  selector: 'app-grants-general-information-charitable',
  templateUrl: './grants-general-information-charitable.component.html',
  styleUrls: ['./grants-general-information-charitable.component.scss']
})
export class GrantsGeneralInformationCharitableComponent implements OnInit, IDeactivateComponent {

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  generalInfoForm: UntypedFormGroup;
  staticformFields: any;
  userType: string = "";
  permission: string = "";
  CharityAppID: string;
  menudata: ModuleMenu;
  therapeuticAreas$: Observable<any>;
  therapeuticAreas1: any=[];
  previouslyReceivedFundDD$: Observable<any>;
  ProgramStartDate: Date = new Date();
  ProgramEndDate: Date = new Date();
  minPStartDate = new Date();
  maxPStartDate: Date | undefined;
  minPEndDate = new Date();
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  currencyType: string = '$';
  orgdetails : Organization;
  operations = [
    {
      name: 'Save',
      type: 'submit',
      callback: this.save,
      self: this
    }
  ];
  uploadedFiles: Document_Upload_File[] = [];

  constructor(
    private readonly commonService: CommonService,
    private readonly userService: UserService,
    private readonly DatashareSerivce: GrantsDatashareService,
    private readonly router: Router,
    private header: HeadService,
    private readonly summaryService: GrantsSummaryService,
  ) {
    this.currencyType = this.userService.getGrantCharitableCurrencySymbol();
    //this.setFormPermissions();
  }

  ngOnInit() {
    
    this.getStaticFiledsData('GCH01');
    this.userType = this.userService.getUserType();
    let orgcode = this.userService.getOrgCode();
    this.orgdetails  = this.commonService.getOrganizationObject(orgcode);
    this.DatashareSerivce.CharityID.subscribe(x => {
      this.CharityAppID = x;
    });

    this.buildCharitableForm();
    // setTimeout(() => { 
    //   this.setFormPermissions();
    //   if (this.permission == "view") {
    //     this.generalInfoForm.disable();
    //   }
    //   else 
    //     {
    //       this.generalInfoForm.enable();
    //     }
    // }, 700);
    
    this.fetchDropDowns();
    this.fetchGeneralInfo();

  }

  private fetchDropDowns() {
    this.fetchTherapeuticAreas();
  }

  fetchTherapeuticAreas() {
    this.summaryService.getLookupList("LU-030").subscribe({
      next: (summary:any) => {
        this.therapeuticAreas1 =[{ label: "Select", value: null, checked: true }].concat(summary);
      },
      error: err => {
        console.error(err);
      }
    });
    // this.therapeuticAreas$ = this.summaryService.getLookupList("LU-030").pipe(
    //   tap(l => {
    //     l.concat({ label: "Select", value: null, checked: true });
    //   })
    // );  
    
  }

  private fetchGeneralInfo() {
    this.summaryService.getCharityGeneralInfo("api/GMGeneralInfoCharitable/Fetch?RecordID=" + this.CharityAppID)
      .subscribe({
        next: summary => {
          if (summary != null && summary != undefined) {

           
            this.generalInfoForm.patchValue(summary);

            if (summary["PROGRAM_START_DATE"] != null && summary["PROGRAM_START_DATE"] != "") {
            //  this.ProgramStartDate = new Date(this.generalInfoForm.controls["PROGRAM_START_DATE"].value);
        
              this.ProgramStartDate = this.commonService.getdisplayedDate(this.generalInfoForm.controls["PROGRAM_START_DATE"].value);
             this.generalInfoForm.controls["PROGRAM_START_DATE"].setValue(this.ProgramStartDate);
            }
            if (summary["PROGRAM_END_DATE"] != null && summary["PROGRAM_END_DATE"] != "") {
              //this.ProgramEndDate = new Date(this.generalInfoForm.controls["PROGRAM_END_DATE"].value);

                 this.ProgramEndDate = this.commonService.getdisplayedDate(this.generalInfoForm.controls["PROGRAM_END_DATE"].value);

              this.generalInfoForm.controls["PROGRAM_END_DATE"].setValue(this.ProgramEndDate);
            }
          
            this.uploadedFiles = summary['UploadedDocuments'] ?? [];

            if (this.extendedForm != undefined && this.extendedForm != null) {
              this.extendedForm.rowid = summary["ID"];
              this.extendedForm.getResponse();
            }
            this.currencyType=summary["CURRENCY_SYMBOL"];
            this.permission=summary["PERMISSION"];

            // By using this permission, page state needs to control.
            if (this.permission == "view") {
              this.generalInfoForm.disable();
            }
            this.setFormPermissions();
           
          }
          else{
           this.userService.getGrantCharitableCurrencySymbol().subscribe(x=>{
              this.currencyType=x["Data"]
            });
          }
          this.generalInfoForm.markAsPristine();
        },
        error: err => {
          console.error(err);
        }
      });
  }

  private setFormPermissions() {     
    //this.permission = "";
      //this.permission = this.commonService.getPagePermission("GCH01");
      if (this.permission == "view") {
        if (this.extendedForm != null && this.extendedForm != undefined) {
          this.extendedForm.permission = this.permission;
          this.extendedForm.ScreenMode = this.permission;
        }
      //  this.generalInfoForm.disable();
      }   

    if (this.permission == "view") {
     // this.generalInfoForm.disable();
      this.operations = [];
    }
    else {
      this.operations = [
        {
          name: 'Save',
          type: 'submit',
          callback: this.save,
          self: this
        }
      ];
    }

    if (this.permission == "view" && this.generalInfoForm!=null && this.generalInfoForm!=undefined) {
      this.generalInfoForm.disable();
    }
    else if(this.generalInfoForm!=null && this.generalInfoForm!=undefined)
      {
        this.generalInfoForm.enable();
      }
  }

  private buildCharitableForm() {
    this.generalInfoForm = new UntypedFormGroup({
      ID: new UntypedFormControl(''),
      APPLICATION_ID: new UntypedFormControl(''),
      APPLICATION_CODE: new UntypedFormControl(''),
      APPLICATION_TITLE: new UntypedFormControl(''),
      THERAPEUTIC_AREA_ID: new UntypedFormControl(null),
      ORG_MISSION_STATEMENT: new UntypedFormControl(''),
      ORG_ANNUAL_OPERATING: new UntypedFormControl(''),
      GEO_FOCUS_ORG: new UntypedFormControl(''),
      REQUESTED_PROGRAM: new UntypedFormControl(''),
      BRIEF_DESC_PROGRAM: new UntypedFormControl(''),
      GOALS_OBJ_PROGRAM: new UntypedFormControl(''),
      GEO_FOCUS_REQUEST: new UntypedFormControl(''),
      PROGRAM_START_DATE: new UntypedFormControl(null),
      PROGRAM_START_DATEO: new UntypedFormControl(null),
      PROGRAM_END_DATE: new UntypedFormControl(null),
      PROGRAM_END_DATEO: new UntypedFormControl(null),
      REQUEST_AMOUNT: new UntypedFormControl(null),
      REQUEST_PROPOSAL: new UntypedFormControl(''),
      PROPOSED_BUDGET: new UntypedFormControl(null),
      ANNUAL_BUDGET: new UntypedFormControl(null),
      IS_PRE_REC_FUND: new UntypedFormControl('')
    });
   
    // Default disabled control
    this.generalInfoForm.markAsPristine();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  save() {
    if (this['self'].validateControls()) {

      this['self'].generalInfoForm.markAsPristine();
      debugger
      let formData = this['self'].generalInfoForm.value;

      formData['PROGRAM_START_DATEO'] = this['self'].GetStartDate();
      formData['PROGRAM_END_DATEO'] = this['self'].GetEndDate();
      if(formData['PROGRAM_END_DATE']!=null && formData['PROGRAM_END_DATE']!="" && formData['PROGRAM_END_DATE']!=undefined)
      formData['PROGRAM_END_DATE'] = new Date();
    else 
    formData['PROGRAM_END_DATE'] =null;
    if(formData['PROGRAM_START_DATE']!=null && formData['PROGRAM_START_DATE']!="" && formData['PROGRAM_START_DATE']!=undefined)
      formData['PROGRAM_START_DATE'] = new Date();
    else 
    formData['PROGRAM_START_DATE'] = null;
      let uploadData = new FormData();
      if (this['self'].uploadedFiles?.length > 0) {
        for (let i = 0; i < this['self'].uploadedFiles.length; i++) {
          if (this['self'].uploadedFiles[i].Status == "Add") {
            uploadData.append(this['self'].uploadedFiles[i].ID, this['self'].uploadedFiles[i].File);
            this['self'].uploadedFiles[i].File = null;
          }
        }
      }
      formData['UploadedDocuments'] = this['self'].uploadedFiles;
      uploadData.append('GM_APP_CHARITABLE', JSON.stringify(formData));

      if (this['self'].CharityAppID == "" || this['self'].CharityAppID == undefined) {

        this['self'].summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Insert', uploadData)
          .subscribe({
            next: result => {
              
              this['self'].generalInfoForm.markAsPristine();
              let tempID = result["TransactionID"]; //Charity ID
              let tempCode = result["TransactionCode"];// Audit Version ID
              let tempAppID = result["Data"];
              this['self'].CharityAppID = tempID;
              this['self'].DatashareSerivce.setGrantApplicationID(tempAppID);
              this['self'].DatashareSerivce.setCharityID(tempID);

              if (result.Status === 0) {
                this['self'].extendedForm.saveControls(tempID, tempAppID, tempCode)
                  .subscribe({
                    next: result1 => {
                      if (result1.Status === 0) {
                        this['self'].commonService.SuccessBanner(result.Message);
                        this['self'].extendedForm.IsFormToched=false;
                        this['self'].refreshPage(tempAppID, tempID);
                        this['self'].fetchGeneralInfo();
                      }
                      else {
                        this['self'].commonService.ValidationBanner(result1.Message);
                        this['self'].refreshPage(tempAppID, tempID);
                        this['self'].fetchGeneralInfo();
                        if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                          this['self'].extendedForm.IsFormToched=false;
                          this['self'].extendedForm.getResponse();
                        }
                      }
                    }
                  });
              }
              else {
                this['self'].commonService.ValidationBanner(result.Message);
              }
            },
            error: err => {
              console.error(err);
            }
          });
      }
      else {
        this['self'].summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Update', uploadData)
          .subscribe({
            next: result => {
              if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                this['self'].fetchGeneralInfo();
                let tempAppID = result["Data"];
                this['self'].extendedForm.saveControls(result.TransactionID, tempAppID, result.TransactionCode)
                  .subscribe({
                    next: result1 => {
                      
                      // this['self'].generalInfoForm.markAsPristine();
                      // if (result1.ErrorCode === "NOCONTROLS") {
                      //   if (result.Status === 0)
                      //   this['self'].commonService.SuccessBanner(result.Message);
                         
                      //   else
                      //   this['self'].commonService.ValidationBanner(result.Message);
                      // }
                      // else {
                      //   if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                      //     this['self'].commonService.ValidationBanner(result.Message);
                      //   }
                      //   else {
                      //     this['self'].commonService.SuccessBanner(result.Message);
                      //     if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                      //       this['self'].extendedForm.getResponse();
                      //     }
                      //   }
                      // }
                      if (result1.ErrorCode === "NOCONTROLS") {
                        if (result.ErrorCode === "NOCHANGES")
                        this['self'].commonService.ValidationBanner(result.Message);
                        else
                        {
                          this['self'].generalInfoForm.markAsPristine();
                          this['self'].commonService.SuccessBanner("General Information saved successfully");
                          this['self'].extendedForm.IsFormToched=false;
                          if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                            this['self'].extendedForm.rowid=result.TransactionID;
                            this['self'].extendedForm.getResponse();
                          }
                        }
                      }
                      else {
                        if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                          this['self'].commonService.ValidationBanner(result.Message);
                        }
                        else {
                          this['self'].generalInfoForm.markAsPristine();
                          this['self'].fetchGeneralInfo();
                          this['self'].commonService.SuccessBanner("General Information saved successfully");
                          this['self'].extendedForm.IsFormToched=false;
                          if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                            this['self'].extendedForm.rowid=result.TransactionID;
                            this['self'].extendedForm.getResponse();
                          }
                        }
                      }
                    },
                    error: err => {
                      console.error(err);
                    }
                  });
              }
              else {
                this['self'].commonService.ValidationBanner(result.Message);
              }
            },
            error: err => {
              console.error(err);
            }
          });
      }
    }
  }

  refreshPage(id: string, transactionID:string) {

    this.summaryService.getCharityAppSummary("api/common/getgrantsapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.ScreenID = transactionID;
      this.commonService.setGrantsApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "GRANTSCHARITABLE";
      this.menudata.operation = "Edit";
      this.menudata.appId = id
      this.menudata.screenID=transactionID;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);

      this.router.navigate(['/home/grants/my-applications/application-ext/:' + id + '/genInformcharitable'], {
        skipLocationChange: true, queryParams: { module: "grants",submodule:this.menudata.module , id: transactionID, app_ext: true, screen_type: "my-applications" }
      });

    });
    this.generalInfoForm.markAsPristine();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.generalInfoForm.value;

    if (this.staticformFields?.APPLICATION_TITLE?.IS_Display) {
      if (this.staticformFields?.APPLICATION_TITLE?.IS_MANDATORY
        && (formData.APPLICATION_TITLE === null || formData.APPLICATION_TITLE === "")) {
        $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.APPLICATION_TITLE?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#APPLICATION_TITLE").addClass("ng-untouched ng-valid");
        $("#APPLICATION_TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.THERAPEUTIC_AREA_ID?.IS_Display) {
      if (this.staticformFields?.THERAPEUTIC_AREA_ID?.IS_MANDATORY
        && (formData.THERAPEUTIC_AREA_ID === null || formData.THERAPEUTIC_AREA_ID === "")) {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-touched ng-invalid validate-error");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.THERAPEUTIC_AREA_ID?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ORG_MISSION_STATEMENT?.IS_Display) {
      if (this.staticformFields?.ORG_MISSION_STATEMENT?.IS_MANDATORY
        && (formData.ORG_MISSION_STATEMENT === null || formData.ORG_MISSION_STATEMENT === "")) {
        $("#ORG_MISSION_STATEMENT").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_MISSION_STATEMENT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_MISSION_STATEMENT?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ORG_MISSION_STATEMENT").addClass("ng-untouched ng-valid");
        $("#ORG_MISSION_STATEMENT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ORG_ANNUAL_OPERATING?.IS_Display) {
      if (this.staticformFields?.ORG_ANNUAL_OPERATING?.IS_MANDATORY
        && (formData.ORG_ANNUAL_OPERATING === null || formData.ORG_ANNUAL_OPERATING === "")) {
        $("#ORG_ANNUAL_OPERATING").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_ANNUAL_OPERATING").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_ANNUAL_OPERATING?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ORG_ANNUAL_OPERATING").addClass("ng-untouched ng-valid");
        $("#ORG_ANNUAL_OPERATING").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GEO_FOCUS_ORG?.IS_Display) {
      if (this.staticformFields?.GEO_FOCUS_ORG?.IS_MANDATORY
        && (formData.GEO_FOCUS_ORG === null || formData.GEO_FOCUS_ORG === "")) {
        $("#GEO_FOCUS_ORG").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_ORG").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_ORG?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#GEO_FOCUS_ORG").addClass("ng-untouched ng-valid");
        $("#GEO_FOCUS_ORG").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.REQUESTED_PROGRAM?.IS_Display) {
      if (this.staticformFields?.REQUESTED_PROGRAM?.IS_MANDATORY
        && (formData.REQUESTED_PROGRAM === null || formData.REQUESTED_PROGRAM === "")) {
        $("#REQUESTED_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUESTED_PROGRAM").addClass("ng-untouched ng-valid");
        $("#REQUESTED_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.BRIEF_DESC_PROGRAM?.IS_Display) {
      if (this.staticformFields?.BRIEF_DESC_PROGRAM?.IS_MANDATORY
        && (formData.BRIEF_DESC_PROGRAM === null || formData.BRIEF_DESC_PROGRAM === "")) {
        $("#BRIEF_DESC_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#BRIEF_DESC_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.BRIEF_DESC_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BRIEF_DESC_PROGRAM").addClass("ng-untouched ng-valid");
        $("#BRIEF_DESC_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GOALS_OBJ_PROGRAM?.IS_Display) {
      if (this.staticformFields?.GOALS_OBJ_PROGRAM?.IS_MANDATORY
        && (formData.GOALS_OBJ_PROGRAM === null || formData.GOALS_OBJ_PROGRAM === "")) {
        $("#GOALS_OBJ_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#GOALS_OBJ_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GOALS_OBJ_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#GOALS_OBJ_PROGRAM").addClass("ng-untouched ng-valid");
        $("#GOALS_OBJ_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GEO_FOCUS_REQUEST?.IS_Display) {
      if (this.staticformFields?.GEO_FOCUS_REQUEST?.IS_MANDATORY
        && (formData.GEO_FOCUS_REQUEST === null || formData.GEO_FOCUS_REQUEST === "")) {
        $("#GEO_FOCUS_REQUEST").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_REQUEST").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_REQUEST?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#GEO_FOCUS_REQUEST").addClass("ng-untouched ng-valid");
        $("#GEO_FOCUS_REQUEST").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_START_DATE?.IS_Display) {
      if (this.staticformFields?.PROGRAM_START_DATE?.IS_MANDATORY
        && (formData.PROGRAM_START_DATE === null || formData.PROGRAM_START_DATE === "")) {
        $("#PROGRAM_START_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_START_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_START_DATE?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_START_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_END_DATE?.IS_Display) {
      if (this.staticformFields?.PROGRAM_END_DATE?.IS_MANDATORY
        && (formData.PROGRAM_END_DATE === null || formData.PROGRAM_END_DATE === "")) {
        $("#PROGRAM_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_END_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_END_DATE?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_END_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_START_DATE?.IS_Display && this.staticformFields?.PROGRAM_END_DATE?.IS_Display) {
      if (formData.PROGRAM_START_DATE != null && formData.PROGRAM_END_DATE != null) {
        if (new Date(formData.PROGRAM_START_DATE) > new Date(formData.PROGRAM_END_DATE)) {
          message += "Program end date cannot be lesser than program start date. Please update the details <br/>";
        isValid = false;
      }
    }
    }

    if (this.staticformFields?.REQUEST_AMOUNT?.IS_Display) {
      if (this.staticformFields?.REQUEST_AMOUNT?.IS_MANDATORY
        && (formData.REQUEST_AMOUNT === null || formData.REQUEST_AMOUNT === "")) {
        $("#REQUEST_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_AMOUNT?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUEST_AMOUNT").addClass("ng-untouched ng-valid");
        $("#REQUEST_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.CGenInfo_AddlDocReq?.IS_Display) {
      if (this.staticformFields?.CGenInfo_AddlDocReq?.IS_MANDATORY && this.uploadedFiles.length == 0) {
        message += `Please upload ${this.staticformFields?.CGenInfo_AddlDocReq?.LABEL_NAME} <br/>`;
        isValid = false;
      }
    }

    if (this.staticformFields?.REQUEST_PROPOSAL?.IS_Display) {
      if (this.staticformFields?.REQUEST_PROPOSAL?.IS_MANDATORY
        && (formData.REQUEST_PROPOSAL === null || formData.REQUEST_PROPOSAL === "")) {
        $("#REQUEST_PROPOSAL").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_PROPOSAL").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_PROPOSAL?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUEST_PROPOSAL").addClass("ng-untouched ng-valid");
        $("#REQUEST_PROPOSAL").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROPOSED_BUDGET?.IS_Display) {
      if (this.staticformFields?.PROPOSED_BUDGET?.IS_MANDATORY
        && (formData.PROPOSED_BUDGET === null || formData.PROPOSED_BUDGET === "")) {
        $("#PROPOSED_BUDGET").addClass("ng-touched ng-invalid validate-error");
        $("#PROPOSED_BUDGET").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PROPOSED_BUDGET?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROPOSED_BUDGET").addClass("ng-untouched ng-valid");
        $("#PROPOSED_BUDGET").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ANNUAL_BUDGET?.IS_Display) {
      if (this.staticformFields?.ANNUAL_BUDGET?.IS_MANDATORY
        && (formData.ANNUAL_BUDGET === null || formData.ANNUAL_BUDGET === "")) {
        $("#ANNUAL_BUDGET").addClass("ng-touched ng-invalid validate-error");
        $("#ANNUAL_BUDGET").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ANNUAL_BUDGET?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ANNUAL_BUDGET").addClass("ng-untouched ng-valid");
        $("#ANNUAL_BUDGET").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.IS_PRE_REC_FUND?.IS_Display) {
      if (this.staticformFields?.IS_PRE_REC_FUND?.IS_MANDATORY
        && (formData.IS_PRE_REC_FUND === null || formData.IS_PRE_REC_FUND === "")) {
        $("#IS_PRE_REC_FUND").addClass("ng-touched ng-invalid validate-error");
        $("#IS_PRE_REC_FUND").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.IS_PRE_REC_FUND?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#IS_PRE_REC_FUND").addClass("ng-untouched ng-valid");
        $("#IS_PRE_REC_FUND").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  // uploadFiles(event) {
  //   if (this.uploadedFiles == undefined || this.uploadedFiles == null)
  //     this.uploadedFiles = [];

  //   if (event.target.files && event.target.files.length) {
  //     for (let i = 0; i < event.target.files.length; i++) {
  //       let uploadFile = new Document_Upload_File();
  //       uploadFile.ID = this.NewGuid();
  //       uploadFile.DOCUMENT_NAME = event.target.files[i].name;
  //       uploadFile.File = event.target.files[i];
  //       uploadFile.Status = "Add";
  //       this.uploadedFiles.push(uploadFile);
  //     }
  //   }
  // }

  uploadFiles(event): void {
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }
let DupFlag=false;
let DOCUMENT_NAME="";
    let hasUnFormat = false;
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;

        uploadFile.ID = this.NewGuid();// this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";

        if (this.uploadedFiles?.length > 0) {
          hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (hasValue?.length > 0) {
          DupFlag=true;
          debugger;
          if(DOCUMENT_NAME!="")
          DOCUMENT_NAME += ","+ uploadFile.DOCUMENT_NAME;
        else 
        DOCUMENT_NAME=uploadFile.DOCUMENT_NAME;
          
        } else {
          if (this.staticformFields.CGenInfo_AddlDocReq.IS_MULTISELECT){
            this.uploadedFiles.push(uploadFile);
            } else {
              if(this.generalInfoForm.controls["ID"].value != null){
                this.uploadedFiles.forEach((item)=>{
                  item.Status="Delete";
                });
                this.uploadedFiles.push(uploadFile);
              } else{          
                this.uploadedFiles=[];
                this.uploadedFiles.push(uploadFile);
              }             
            }
        }
      }
    }
if(DupFlag)
this.commonService.ValidationBanner("File already exists with " + DOCUMENT_NAME + " Please update the unique file name");
    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
  }

  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  DownloadFile(fileID) 
  {debugger;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    //debugger;
    this.commonService.previewFile(fileID, fileName, "med");
  }

  NewGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe({
        next: summary => {
          this.staticformFields = summary["Data"];
debugger
          // IS_PRE_REC_FUND field dropdown dynamic values
         // this.staticformFields?.IS_PRE_REC_FUND?.GROUP_VALUES_LIST?.push({ label: "Select", value: null, checked: true });
         let vx=[{ label: "Select", value: null, checked: true }].concat(this.staticformFields?.IS_PRE_REC_FUND?.GROUP_VALUES_LIST);
         this.previouslyReceivedFundDD$ = of(vx);
        }
      });
  }

  CompareDates(olddate: any, newDate: any): boolean {
   
    if (olddate != '' && olddate != undefined && olddate != null) {
  
      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }


  startDateSelect(event) {
   // this.minPEndDate = event;
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
   // this.maxPStartDate = event;
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    let formModel = this.generalInfoForm.getRawValue();
    const lDate = new Date(formModel.PROGRAM_START_DATE);
    // const lDate = formModel.PROGRAM_START_DATE== null?null :  
    if ((this.CompareDates(this.ProgramStartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) &&
     formModel.PROGRAM_START_DATE != null) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Full_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.generalInfoForm.value;
    // const lDate = new Date(formModel.PROGRAM_END_DATE);
    const lDate =new Date(formModel.PROGRAM_END_DATE);
    if ((this.CompareDates(this.ProgramEndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.PROGRAM_END_DATE!=null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
    else {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
  return this.Full_End_Date;
  }

  canExit() {
    if (this.generalInfoForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}

